import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/axios';
import type { HelpContext } from '@/components/onboarding-tour/help-content/types';

/**
 * Estado real desta propriedade, consumido pela ajuda contextual pra mostrar
 * o valor vigente de cada regra em vez de só descrever o comportamento.
 *
 * A tela vai como parâmetro porque o backend calcula os contadores só dela —
 * é o que mantém o endpoint barato conforme a ajuda cobre mais telas. Busca
 * só quando o painel abre e segura o resultado por alguns minutos.
 */
export const useHelpContextQuery = (enabled: boolean, screen: string) => useQuery({
  queryKey: ['help-context', screen],
  queryFn: async () => (
    await api.get<{ data: HelpContext }>('/v1/ajuda/contexto', { params: { tela: screen } })
  ).data.data,
  enabled,
  staleTime: 60 * 1000,
});
